import axios from 'axios';

import {
  GET_BRANDS_URL,
  GET_SUBBRANDS_URL,
  GET_MODELS_URL,
  GET_VERSIONS_URL,
  GET_ACTIVITIES_URL,
  GET_NATIONALITIES_URL,
  GET_SEPOMEX_URL,
  GET_GENDERS_URL,
  GET_MARITAL_STATUSES_URL,
  GET_OCCUPATIONS_URL,
  GET_PERSON_TYPE_URL,
  GET_TAX_REGIMES_URL,
  GET_VEHICLE_SERVICES_URL,
  GET_VEHICLES_TYPES_URL,
  GET_USES_OF_THE_VEHICLE_URL,
  GET_BENEFICIARIES_URL,
} from '../constants/constants';

const headers = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json;charset=utf-8',
});

// FORM 2
export const getBrands = (token, typeVehicle) => {
  return axios.get(
    GET_BRANDS_URL,
    {
      headers: headers(token),
      params: { typeVehicle },
    },
  );
};

export const getSubbrands = (token, typeVehicle, brand) => {
  return axios.get(
    GET_SUBBRANDS_URL.replace('%BRAND%', brand).toLowerCase(),
    {
      headers: headers(token),
      params: { typeVehicle },
    },
  );
};

export const getModels = (token, typeVehicle, brand, subbrand) => {
  const modelsUrl = GET_MODELS_URL
    .replace('%BRAND%', brand)
    .replace('%SUBBRAND%', subbrand)
    .toLowerCase();

  return axios.get(
    modelsUrl,
    {
      headers: headers(token),
      params: { typeVehicle },
    },
  );
};

export const getVersions = (token, typeVehicle, brand, subbrand, model) => {
  const versionsUrl = GET_VERSIONS_URL
    .replace('%BRAND%', brand)
    .replace('%SUBBRAND%', subbrand)
    .replace('%MODEL%', model)
    .toLowerCase();

  return axios.get(
    versionsUrl,
    {
      headers: headers(token),
      params: { typeVehicle },
    },
  );
};

export const getActivities = (token) => {
  return axios.get(GET_ACTIVITIES_URL, { headers: headers(token) });
};

export const getNationalities = (token) => {
  return axios.get(GET_NATIONALITIES_URL, { headers: headers(token) });
};

export const getSEPOMEX = (token, postalCode) => {
  return axios.get(
    GET_SEPOMEX_URL.replace('%POSTALCODE%', postalCode),
    { headers: headers(token) },
  );
};

export const getMaritalStatuses = (token) => {
  return axios.get(
    GET_MARITAL_STATUSES_URL,
    { headers: headers(token) },
  );
};

export const getGenders = (token) => {
  return axios.get(
    GET_GENDERS_URL,
    { headers: headers(token) },
  );
};

export const getOccupations = (token) => {
  return axios.get(
    GET_OCCUPATIONS_URL,
    { headers: headers(token) },
  );
};

export const getTaxRegimes = (token) => {
  return axios.get(
    GET_TAX_REGIMES_URL,
    { headers: headers(token) },
  );
};

export const getPersonType = (token) => {
  return axios.get(
    GET_PERSON_TYPE_URL,
    { headers: headers(token) },
  );
};

export const getUsesOftheVehicle = (token, id) => {
  return axios.get(
    GET_USES_OF_THE_VEHICLE_URL.replace('%VEHICLE_TYPE_ID%', id),
    { headers: headers(token) },
  );
};

export const getVehiclesTypes = (token) => {
  return axios.get(
    GET_VEHICLES_TYPES_URL,
    { headers: headers(token) },
  );
};

export const getVehicleServices = (token) => {
  return axios.get(
    GET_VEHICLE_SERVICES_URL,
    { headers: headers(token) },
  );
};

export const getBeneficiaries = (token) => {
  return axios.get(
    GET_BENEFICIARIES_URL,
    { headers: headers(token) },
  );
};
